import R from 'ramda';

// TODO: [1] consider spreading props other than heroData to avoid confusion when adding new props to Hero
export const heroImageProps = ({
  heroData,
  heroImageClassName,
  heroSecondaryImageClassName,
  imageHasLink,
}) => ({
  imageSrc: R.prop('imageSrc')(heroData),
  alt: R.prop('alt')(heroData),
  imageSrcSet: R.prop('imageSrcSet')(heroData),
  imageSecondarySrc: R.prop('imageSecondarySrc')(heroData),
  imageSecondaryAlt: R.prop('imageSecondaryAlt')(heroData),
  imageSecondarySrcSet: R.prop('imageSecondarySrcSet')(heroData),
  heroTag: R.prop('heroTag')(heroData),
  links: R.prop('links')(heroData),
  heroImageClassName,
  heroSecondaryImageClassName,
  imageHasLink,
});

// TODO: [1] consider spreading props other than heroData to avoid confusion when adding new props to Hero
export const heroContentProps = ({
  heroData,
  isUnderlined,
  heroContentClassName,
  heroContentBoxClassName,
  heroWrapperContentClassName,
  labelExtraClass,
  headingExtraClass,
  headingIntroExtraClass,
  descriptionExtraClass,
  ctaExtraClass,
  ctaType,
  headingLevel,
  onClick,
  headingHasLink,
  openLinkInNewTab,
}) => ({
  heading: R.prop('heading')(heroData),
  headingIntroduction: R.prop('headingIntroduction')(heroData),
  label: R.prop('label')(heroData),
  description: R.prop('description')(heroData),
  links: R.prop('links')(heroData),
  isUnderlined,
  heroContentClassName,
  heroContentBoxClassName,
  heroWrapperContentClassName,
  labelExtraClass,
  headingExtraClass,
  headingIntroExtraClass,
  descriptionExtraClass,
  ctaExtraClass,
  ctaType,
  headingLevel,
  onClick,
  headingHasLink,
  openLinkInNewTab,
});
